import { useMemo } from 'react';
import { useGameStore } from '../GameStoreContext.ts';
import { usePlayerValidators } from './usePlayerValidators.ts';
import { MechanicValidatorDevelopmentCard } from '@colonist/game-mechanic-validators';
import { useMapValidator } from './useMapValidator.ts';
import { useCurrentStateValidator } from './useCurrentStateValidator.ts';
export const useMechanicValidatorDevelopmentCard = ()=>{
    const { playerValidators } = usePlayerValidators();
    const mapValidator = useMapValidator();
    const currentStateValidator = useCurrentStateValidator();
    const mechanicDevelopmentCardsState = useGameStore((state)=>state.gameState.mechanicDevelopmentCardsState);
    return useMemo(()=>{
        if (!mechanicDevelopmentCardsState) return undefined;
        return new MechanicValidatorDevelopmentCard(playerValidators, mapValidator, currentStateValidator, mechanicDevelopmentCardsState);
    }, [
        playerValidators,
        mapValidator,
        currentStateValidator,
        mechanicDevelopmentCardsState
    ]);
};
